export default __webpack_public_path__ + "static/media/womanportrait.fcd89fb4.jpg";